import React, { useCallback, useRef, useState } from 'react';
import RMSCommonDialog from '../../../shared/components/dialog/RMSCommonDialog';
import { getFullPermissions } from 'reducers/PermissionsReducer';
import PersonFormFields from './PersonFormFields';

const AddPersonDialog = ({ open, onClose, personId = null, onPersonCreated, onPersonUpdated }) => {
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const isEditMode = Boolean(personId);
  const personPerms = getFullPermissions('globals', 'People', 'any');
  const canSavePerson = isEditMode ? personPerms.Edit : personPerms.Create;

  const handleClose = useCallback(() => {
    formRef.current?.resetForm();
    onClose?.();
  }, [onClose]);

  const handleSaved = useCallback(
    (person, { isEditMode: wasEditMode }) => {
      if (wasEditMode) {
        onPersonUpdated?.(person);
      } else {
        onPersonCreated?.(person);
      }
      handleClose();
    },
    [onPersonUpdated, onPersonCreated, handleClose]
  );

  return (
    <RMSCommonDialog
      open={open}
      title={isEditMode ? 'Edit Person' : 'Add Person'}
      onClose={handleClose}
      onSave={() => formRef.current?.submit()}
      loading={loading}
      saveDisabled={loading || !canSavePerson}
      maxWidth="lg"
      fullWidth
      closeOnBackdropClick={false}
      className="add-person-dialog"
      saveButton={{
        show: true,
        type: 'simple',
        label: 'Save',
        variant: 'contained',
        color: 'primary',
      }}
      cancelButton={{
        show: true,
        type: 'simple',
        label: 'Cancel',
        variant: 'outlined',
        color: 'secondary',
      }}>
      <PersonFormFields
        ref={formRef}
        open={open}
        personId={personId}
        onSaved={handleSaved}
        onLoadingChange={setLoading}
      />
    </RMSCommonDialog>
  );
};

export default AddPersonDialog;
